import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IaAssistantComponent } from './components/ia-assistant/ia-assistant.component';
import { AuthGuard } from 'src/app/core/guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./components/assistant-form/assistant-form.component').then(m => m.AssistantFormComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'list',
    loadComponent: () => import('./components/assistants-list/assistants-list.component').then(m => m.AssistantsListComponent),
    canActivate: [AuthGuard],

  },
  {
    path: 'dashboard',
    loadComponent: () => import('./components/assistants-dashboard/assistants-dashboard.component').then(m => m.AssistantsDashboardComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'page/:idTelar',
    component: IaAssistantComponent,
    data: { page: true }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AssistantRoutingModule { }
